var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className},_vm._l((_vm.data.children),function(component,i){return _c(component.typeHandle,{key:("block-row-children-" + i),tag:"component",attrs:{"data":component}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }